<template>
  <div class="data_brain_wrap">
    <div class="brain_title">极智峰科技</div>
    <div class="brain_desc">创新驱动、智链千行，引领培育未来产业新生态</div>

    <el-row class="card_wrap" type="flex">
      <el-col
        class="brain_item"
        :lg="7"
        :sm="11"
        :xs="11"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div class="item_title">{{ item.title }}</div>
        <div class="item_desc">{{ item.desc }}</div>
        <div class="item_navigate" @click="handleNavigate(item.url)">{{ item.type }}</div>
        <div class="item_bg"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          title: '大模型',
          desc: 'AI、智能体与知识库的深度融合，三者协同突破传统AI的被动响应局限，形成“知识-思考-行动”的智能增强生态。',
          type: '了解详情 >>',
          url: 'https://ai.jizhifeng.com',
        },
        {
          title: '学科管理',
          desc: '将分散的统计工作升级为“数据采集-智能分析-战略反哺”的闭环生态，助力高校实现从经验驱动到数据驱动的治理模式转型。',
          type: '了解详情 >>',
          url: 'https://xk.jizhifeng.com',
        },
        {
          title: '智库系统',
          desc: '集学术资源管理、成果转化追踪、专家库建设于一体的综合性平台，旨在实现科研数据的高效整合与价值释放。',
          type: '了解详情 >>',
          url: 'https://zk.jizhifeng.com',
        },
        {
          title: '校友会',
          desc: '集校友信息统计、就业追踪、人脉网络构建于一体的数字化平台，旨在实现校友资源的深度整合与动态管理',
          type: '了解详情 >>',
          url: 'https://xyh.jizhifeng.com',
        },
        {
          title: '商协会',
          desc: '集会员管理、活动统筹、组织优化与信息互通于一体的综合性治理工具，旨在提升商协会服务效能并强化政企协同。',
          type: '暂未开放',
          url: '',
        },
        {
          title: '智能物联网中控',
          desc: '通过集成多协议通信、智能算法与可视化界面，实现对展厅硬件设备、灯光环境、主题场景及软件授权的全链路集中控制，为展厅运营提供高效、灵活的技术支撑。',
          type: '敬请期待',
          url: '',
        },
      ],
    }
  },
  methods:{
    handleNavigate(url){
      if(url === ''){
        return
      }
      window.location.href = url;

    }
  }
}
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 50px 0;
  background: #e8eef2;
  text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
    }
  }
  .card_wrap {
    width: 70%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-around;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40PX;
        border-radius: 10PX;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20PX;
        &:nth-child(-n+2){
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg{
        opacity: 1;
      }
      &:hover .item_title {
        color: #fff;
      }
      &:hover .item_desc {
        color: #fff;
      }
      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110PX;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_navigate {
        width: 100PX;
        height: 30PX;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10PX;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
